var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSs3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5493 9.31426L32.4543 14.4109C32.2193 14.6459 31.901 14.7776 31.5693 14.7776H26.4727C25.7827 14.7776 25.2227 14.2176 25.2227 13.5276V8.43093C25.2227 8.09926 25.3543 7.78092 25.5893 7.54593L30.686 2.45092C30.9927 2.14426 31.436 2.01759 31.8577 2.11759C32.2793 2.21759 32.6193 2.52759 32.756 2.93926L33.8327 6.16759L37.061 7.24426C37.4727 7.38093 37.7827 7.72093 37.8827 8.14259C37.9827 8.56426 37.856 9.00759 37.5493 9.31426Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5897 12.6436C26.078 12.1553 26.8697 12.1553 27.358 12.6436C27.8463 13.1319 27.8463 13.9236 27.358 14.4119L19.713 22.0553C19.2247 22.5436 18.433 22.5436 17.9463 22.0553C17.458 21.5686 17.458 20.7769 17.9463 20.2886L25.5897 12.6436Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.208 15.014C34.988 16.9407 35.4163 19.0457 35.4163 21.2507C35.4163 30.449 27.948 37.9173 18.7497 37.9173C9.55134 37.9173 2.08301 30.449 2.08301 21.2507C2.08301 12.0523 9.55134 4.58398 18.7497 4.58398C20.9547 4.58398 23.0597 5.01232 24.9863 5.79232L24.4113 6.36732C23.8647 6.91565 23.5563 7.65732 23.5563 8.43065V12.009C22.118 11.259 20.483 10.834 18.7497 10.834C13.0013 10.834 8.33301 15.5023 8.33301 21.2507C8.33301 26.999 13.0013 31.6673 18.7497 31.6673C24.498 31.6673 29.1663 26.999 29.1663 21.2507C29.1663 19.5173 28.7413 17.8823 27.9913 16.444H31.5697C32.343 16.444 33.0847 16.1357 33.633 15.589L34.208 15.014ZM26.0163 18.1073C26.4347 19.0723 26.6663 20.134 26.6663 21.2507C26.6663 25.6207 23.1197 29.1673 18.7497 29.1673C14.3797 29.1673 10.833 25.6207 10.833 21.2507C10.833 16.8807 14.3797 13.334 18.7497 13.334C19.8663 13.334 20.928 13.5657 21.893 13.984L16.7663 19.109C15.628 20.2473 15.628 22.0957 16.7663 23.234C17.9047 24.3723 19.753 24.3723 20.8913 23.234L26.0163 18.1073Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs3);
export default __webpack_public_path__ + "static/media/ss3.6287e81da7d3f9a56d5d06e81e3aeb08.svg";
export { ForwardRef as ReactComponent };